"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListReplicaCampaignNegativeKeywordSnapshotQuerySchema = exports.ListReplicaCampaignNegativeKeywordQuerySchema = exports.UpdateReplicaCampaignNegativeKeywordsBodySchema = exports.UpdateReplicaCampaignNegativeKeywordBodySchema = exports.ListReplicaCampaignNegativeKeywordSnapshotResponseSchema = exports.ListReplicaCampaignNegativeKeywordResponseSchema = exports.ReplicaCampaignNegativeKeywordSnapshotSchema = exports.ReplicaCampaignNegativeKeywordSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const apple_proxy_web_1 = require("../../apple-proxy-web");
const common_1 = require("./common");
exports.ReplicaCampaignNegativeKeywordSchema = (0, core_1.StrictObject)({
    ...common_1.ReplicaMetadataFields,
    keywordRef: ruby_1.AppleProxyRefSchema,
    body: apple_proxy_web_1.AppleProxyNegativeKeywordSchema,
    keywordId: typebox_1.Type.Optional(core_1.IdSchema),
    duration: core_1.DurationSchema,
});
exports.ReplicaCampaignNegativeKeywordSnapshotSchema = exports.ReplicaCampaignNegativeKeywordSchema;
/**
 * Response
 */
exports.ListReplicaCampaignNegativeKeywordResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaCampaignNegativeKeywordSchema);
exports.ListReplicaCampaignNegativeKeywordSnapshotResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaCampaignNegativeKeywordSnapshotSchema);
/**
 * Body
 */
exports.UpdateReplicaCampaignNegativeKeywordBodySchema = (0, core_1.StrictObject)({
    body: apple_proxy_web_1.AppleProxyNegativeKeywordSchema,
});
exports.UpdateReplicaCampaignNegativeKeywordsBodySchema = (0, core_1.StrictObject)({
    ...common_1.ReplicaMetadataFields,
    keywords: typebox_1.Type.Array(exports.UpdateReplicaCampaignNegativeKeywordBodySchema),
});
/**
 * Parameters
 */
exports.ListReplicaCampaignNegativeKeywordQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...common_1.ReplicaMetadataQueryFields,
    keywordRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    keywordId: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.IdSchema)),
});
exports.ListReplicaCampaignNegativeKeywordSnapshotQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...common_1.ReplicaMetadataSnapshotQueryFields,
    keywordRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    keywordId: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.IdSchema)),
});
